import React from "react";
import Page from "./Page";

/** Auto choose quote band height based on text length so short pages look full */
function pickBandClass(sec) {
  if (!sec) return "";
  const text = [
    sec.heading || "",
    ...(Array.isArray(sec.paragraphs) ? sec.paragraphs : []),
  ].join(" ");
  const len = text.length;

  if (len <= 600)  return "page--quoteXXL";  // very short → biggest band
  if (len <= 1000) return "page--quoteXL";   // short
  if (len <= 1400) return "page--quoteL";    // medium
  return "";                                  // long → default band
}

/** Repeat/trim quotes to match number of sections */
function fitQuotes(quotes, count) {
  if (!Array.isArray(quotes) || quotes.length === 0) return Array(count).fill("");
  const out = [];
  for (let i = 0; i < count; i++) out.push(quotes[i % quotes.length]);
  return out;
}

/**
 * Renders a full journal (cover + sections) using the safe Page wrapper.
 * data: { title, coverPoem, sections:[{heading, paragraphs:[]}] }
 * quotes: optional array of per-page quotes (auto-fitted)
 * skin: "page--whisper" (gradient) or "page--white"
 */
export default function JournalPages({ data, quotes = [], skin = "page--whisper" }) {
  const title = data?.title || "Journal";
  const coverPoem = data?.coverPoem || "";
  const sections = Array.isArray(data?.sections) ? data.sections : [];
  const pageQuotes = fitQuotes(quotes, sections.length);

  return (
    <>
      {/* Cover page (no footer) */}
      <Page hideFooter pageNumber={null} quote="" className={skin}>
        <h1 style={{ color: "#fff", textAlign: "center", margin: "0 0 8mm 0", fontSize: 28 }}>
          {title}
        </h1>
        {coverPoem && (
          <p style={{ color: "#fff", whiteSpace: "pre-line", textAlign: "center" }}>
            {coverPoem}
          </p>
        )}
      </Page>

      {/* Content pages */}
      {sections.map((sec, i) => {
        const bandClass = pickBandClass(sec);
        return (
          <Page
            key={i}
            pageNumber={i + 2}                       // cover is page 1
            quote={pageQuotes[i] || ""}
            className={`${skin} ${bandClass}`}        // auto band size
          >
            {sec?.heading && (
              <h2 style={{ color: "#fff", textAlign: "center" }}>
                {sec.heading}
              </h2>
            )}
            {(sec?.paragraphs || []).map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </Page>
        );
      })}
    </>
  );
}
